/**
 * @class FlashMessage
 */
export default class FlashMessage {
    /**
     * @param {String} type
     * @param {String} name
     */
    constructor(type, text) {
        this._type = type;
        this._text = text;
    }

    /**
     * @return {String}
     */
    get type() {
        return this._type;
    }

    /**
     * @param {String} type
     */
    set type(type) {
        this._type = type;
    }

    /**
     * @return {String}
     */
    get text() {
        return this._text;
    }

    /**
     * @param {String} text
     */
    set text(text) {
        this._text = text;
    }

    /**
     * @return {String}
     */
    toString() {
        return "FlashMessage (" + this._type + ")";
    }
}
